<template>
    <div class="publication__cards  d-flex">
        <div class="publication__card d-flex" v-for="(_item, _idx) in initial">

            <div class="publication__card-left">
                <div class="publication__card-header  d-flex">
                    <img :src="_item.icon" class="publication__card-icon" alt="" v-if="_item.icon">
                    <h3 class="publication__card-title">{{$store.getters.t(_item.title)}}</h3>
                </div>

                <div class="publication__card-description">{{$store.getters.t(_item.description)}}</div>
            </div>
            <div class="publication__card-right d-flex">

              <a :href="_item.link" class="btn publication__btn" v-if="_item.link" @click="setFacility( _item.key )">
                  {{$store.getters.t('common_choose')}}
              </a>

            </div>

        </div>
    </div>
</template>

<script>

const createFacility = {
    autoHelp:       {
        key: 'auto_help',
        title: 'publication_facilities_card_auto_help_title',
        icon: '/assets/images/icons/publication-autohelp.svg',
        description: 'publication_facilities_card_auto_help_desc',
        link: '/publication/facility',
    },
    photoHelp:       {
        key: 'photo_help',
        title: 'publication_facilities_card_photo_help_title',
        icon: '/assets/images/icons/publication-photo-help.svg',
        description: 'publication_facilities_card_photo_help_desc',
        link: '/publication/facility',
    },
    giveAway:       {
        key: 'giveaway',
        title: 'publication_facilities_card_giveaway_title',
        icon: '/assets/images/icons/publication-giveaway.svg',
        description: 'publication_facilities_card_giveaway_desc',
        link: '/publication/facility',
    },
    homestay:       {
        key: 'homestay',
        title: 'publication_facilities_card_homestay_title',
        icon: '/assets/images/icons/publication-home.svg',
        description: 'publication_facilities_card_homestay_desc',
        link: '/publication/homestay',
    },
}


import StateMixin from "./mixins/StateMixin";


export default {
    name: "PublicationCreateFacilities",
    mixins: [StateMixin],
    data(){
      return{
        selected: null
      }
    },
    computed: {

        initial() { return createFacility },

    },

    methods:{
        setFacility( type ){

            this.SET_PUBLICATION_TYPE(type)

      }
    }

}
</script>

<style scoped>

</style>
